import { Modal } from "grabcad-ui-elements";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
    width: 420px !important;
    max-width: 90vw !important;

    > .content {
        padding: 0 !important;
        border-radius: 12px !important;
        overflow: hidden;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    width: 100%;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    width: 100%;
`;
